"use client";

import { memo } from "react";
import type { UseCaseLanguagesProps } from "./types";
import { useCaseLanguagesData } from "./constants";
import {
  LanguagesSection,
} from "@/components/screen/global-components/language";

const UseCaseLanguages = ({
  className,
}: UseCaseLanguagesProps) => {
  return (
    <LanguagesSection
      className={className}
      {...useCaseLanguagesData}
    />
  );
};

export default memo(UseCaseLanguages);
